import { useEmbeddedEditorContext } from './EmbeddedEditorContext';
const HideInStudioWrapper = ({
  children,
  renderFallbackComponent
}) => {
  const {
    isInsideMarketingStudio
  } = useEmbeddedEditorContext();
  if (isInsideMarketingStudio) {
    if (renderFallbackComponent) {
      return renderFallbackComponent();
    }
    return null;
  }
  return children;
};
export default HideInStudioWrapper;